import { render, staticRenderFns } from "./AuthPopup.vue?vue&type=template&id=03a5d262&scoped=true&"
import script from "./AuthPopup.vue?vue&type=script&lang=js&"
export * from "./AuthPopup.vue?vue&type=script&lang=js&"
import style0 from "./AuthPopup.vue?vue&type=style&index=0&id=03a5d262&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a5d262",
  null
  
)

export default component.exports